import axios from 'axios'

export enum SearchCategory  {
    All = 'txt_idx',
    Title = 'title',
    Content = 'content',
    CreatedUser = 'createdusername',
    Hashtag = 'tags'
}

export enum SortMethod {
    Relevance,
    UpdatedDate
}

interface Row<T> {
    fields: T;
    sortkey: string[];
    location: {
        netaddr: string;
        rowid: number;
        table: string;
        volume: string;
    }
}       

interface AxiosResult<T> {            
    total_count: number;
    rows: Row<T>[];
}

declare global {
    namespace konan {
        export interface SearchParam {
            keyword: string;
            searchCategory: SearchCategory;
            sort: SortMethod;
            page: number;
            itemsPerPage: number;
            startDate?: string;
            endDate?: string;
        }

        export interface SearchResult<T> {
            totalCount: number;
            result: T[];
        }
    }
}

export class KonanSearch {
    private highlight = '{"title":{"length":1000,"begin":"<mark>","end":"</mark>"}},{"content":{"length":1000,"begin":"<mark>","end":"</mark>"}},{"tags":{"length":10000,"begin":"<mark>","end":"</mark>"}},{"filecontent":{"length":500,"begin":"<mark>","end":"</mark>","delim":"!##@@##!", "complex":"MULTIPOINT"}},{"attachfiles":{"length":10000,"begin":"<mark>","end":"</mark>"}}';
    private serviceUrl: string = "";
    private volumeName: string = "";
    
    constructor(serviceHost?: string, volumeName?: string) {        
        var host = serviceHost || location.host;
        this.serviceUrl = `https://${host}/search5`;
        this.volumeName = volumeName || 'articles.articles';
    }

    private getLogQuery(searchCategory: SearchCategory, page: number, keyword: string): string {
        return `${searchCategory}|${page}|정확도순^${keyword}]`
    }

    search<T>(param: konan.SearchParam, comCode?: string): Promise<konan.SearchResult<T>> {
        let offset = (param.page - 1) * param.itemsPerPage;
        let keyword = '';
        let whereClause = ''
        let searchResult: konan.SearchResult<T> = {
            totalCount: 0,
            result: []
        }

        if(param.keyword.trim().length == 0) {
            return Promise.resolve(searchResult);
        } else {
            keyword = param.keyword.trim();
        }

        if(keyword.startsWith('#')) {
            keyword = keyword.slice(1);
        }        

        if(param.searchCategory == SearchCategory.All) {
            whereClause = `${SearchCategory.All} = '${keyword}' ALLWORD`;            
        } else {
            whereClause = `${param.searchCategory} = '${keyword}' ALLWORD`;
        }

        if(comCode) {
            whereClause = `${whereClause} AND comcode = '${comCode}'`
        }

        var startDate = param.startDate?.replace(/-/g, '');
        var endDate = param.endDate?.replace(/-/g, '');

        if(param.startDate && param.endDate) {
            whereClause = `${whereClause} AND updateddate BETWEEN '${startDate}' AND '${endDate}'`
        } else if (param.startDate) {
            whereClause = `${whereClause} AND updateddate >= '${startDate}'`
        } else if(param.endDate) {
            whereClause = `${whereClause} AND updateddate <= '${endDate}'`
        }

        if(param.sort == SortMethod.Relevance) {
            whereClause = `${whereClause} ORDER BY $RELEVANCE DESC`;
        } else if (param.sort == SortMethod.UpdatedDate) {
            whereClause = `${whereClause} ORDER BY updateddate DESC`;
        }

        return axios.get(this.serviceUrl, {
            params: {
                select: '*',
                from: this.volumeName,
                where: whereClause,
                offset: offset,
                'hilite-fields': this.highlight,
                custom: this.getLogQuery(param.searchCategory, param.page, param.keyword),
                pagelength: param.itemsPerPage
            }
        }).then((res: any) => {                     
            if(res.status === 200) {
                var returnData = res.data.result as AxiosResult<T>;         
                searchResult.result = returnData.rows.map(r => r.fields);
                searchResult.totalCount = returnData.total_count;
            } 

            return searchResult;
        }).catch(err => { 
            console.log(err); 
            return searchResult;
        });      
    }
}